<template>
  <div id="app">
    <HomeHead
      v-if="show"
      @logoutBack="logoutReload"
      v-show="
        $route.path != '/examCover' && $route.path != '/text' && $route.path != '/text1'
      "
    ></HomeHead>
    <div>
      <router-view v-if="isRouterAlive" />
    </div>
    <HomeFooter
      v-if="show"
      v-show="
        $route.path != '/examCover' && $route.path != '/text' && $route.path != '/text1'
      "
    ></HomeFooter>
  </div>
</template>

<script>
// import HomeHead from "@/view/base/homeHead.vue";
// import HomeFooter from "@/view/base/homeFooter.vue";
import HomeHead from "@/view/base/head.vue";
import HomeFooter from "@/view/base/footer.vue";
export default {
  name: "App",
  data() {
    return {
      show: true,
      isRouterAlive: true,
    };
  },
  created() {
    let userAgentInfo = navigator.userAgent;
    let Agents = new Array(
      "Android",
      "iPhone",
      "SymbianOS",
      "Windows Phone",
      "iPad",
      "iPod"
    );
    let flag = true;
    for (let v = 0; v < Agents.length; v++) {
      if (userAgentInfo.indexOf(Agents[v]) > 0) {
        flag = false;
        break;
      }
    }
    if (!flag) {
      if (this.$route.name == "infoDetail") {
        window.location.href =
          // "https://m.hongdw.com/#/pages/informationBulletin/informationDetail?id=" +
          this.$route.query.id;
      } else if (this.$route.name == "courseDeatil") {
        window.location.href =
          // "https://m.hongdw.com/#/pages/highQualityCourse/playVideo?id=" +
          this.$route.query.id;
      } else {
        window.location.href =
          "https://www.sjzhrgroup.com:808" +
          "?timestamp=" +
          new Date().getTime() +
          Math.random();
        // this.$router.push({ path: "/phone" });
        //  this.show = false;
      }
    }
    if (this.$route.name == "weixin") {
      this.show = false;
    }
  },
  components: {
    HomeHead,
    HomeFooter,
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(() => {
        this.isRouterAlive = true;
      });
    },
    logoutReload() {
      this.reload();
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/App.vue